import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import axios from '@axios'
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import GTMPlugin from './plugins/gtm'

// Interceptor dual-token : l'espace admin DOMICIALIZ utilise un JWT distinct
// (localStorage.domAdminToken) stocké séparément de celui de l'espace client.
// Le token est injecté via le header x-access-token sur les URLs /admindom/*.
//
// Doit rester APRÈS le bloc d'imports : ESLint (import/first) refuse tout
// import placé après une instruction, et c'est ce qui cassait le build de
// production — `import axios from '@axios'` étant un import nommé, il est
// aussi soumis à import/order, d'où sa place dans le groupe des alias.
axios.interceptors.request.use(cfg => {
  const url = cfg.url || ''
  if (url.includes('/admindom')) {
    const t = localStorage.getItem('domAdminToken')
    if (t) cfg.headers['x-access-token'] = t
  }
  return cfg
})

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Installation du plugin GTM
Vue.use(GTMPlugin, { id: 'GTM-T5CL2LD' })

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
